import {Icon, Table} from '@wandb/components';
import React from 'react';
import {useNumberFormatter} from 'react-aria';

import type {FolderData} from '../types';
import {getByteUnit} from './getByteUnit';

interface FolderRowProps {
  folder: FolderData;
  path: string[];
  folderName: string;
  onSetFilePath(path: string[]): void;
}

export function FolderRow({
  folder,
  folderName,
  path,
  onSetFilePath,
}: FolderRowProps) {
  const subFolderCount = Object.keys(folder.subdirectories).length;
  const fileCount = folder.totalFileCount;
  const newPath = path.concat([folderName]);
  const {value, unit} = getByteUnit(folder.totalSize);
  const formatter = useNumberFormatter({
    style: 'unit',
    unit,
    unitDisplay: 'narrow',
    maximumFractionDigits: 1,
  });

  return (
    <Table.Row onAction={() => onSetFilePath(newPath)}>
      <Table.Cell>
        <div className="flex items-center gap-10 p-2">
          <Icon icon="folder-project" size="lg" />
          {folderName}&nbsp;/
        </div>
      </Table.Cell>
      <Table.Cell>
        {subFolderCount !== 0 &&
          subFolderCount +
            (subFolderCount === 1 ? ' subfolder, ' : ' subfolders, ')}
        {fileCount + (fileCount === 1 ? ' file' : ' files')}
      </Table.Cell>
      <Table.Cell>{formatter.format(value)}</Table.Cell>
      <Table.Cell />
    </Table.Row>
  );
}
